import styles from './dragSortAffordance.module.scss'

// the shared useDragSort item affordance (dragging opacity, drop-target tint, drop-side
// accent); spread on the host element beside getItemProps/getHandleProps so every
// sortable list keeps identical visuals. Same shared-className-from-a-module pattern as
// `libs/webui/data-tools/src/DataTable/selectedRow.ts:6`.
export const dragSortItemClassName = styles.dragSortItem
